module.exports = "/work-site/img/warm_level.91a2455b.png";